import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 'id',
      idVista: [9, 23, 45, 46, 50, 52, 53, 76, 77, 79],
      label: i18n.t('app.id')
    }, 
    {
      id: 'name',
      idVista: [12, 45, 46, 48, 50, 52, 53, 76, 77, 79, 80, 81, 90],
      label: i18n.t('app.name') 
    }, 
    {
      id: 'name',
      idVista: [9, 23],
      label: i18n.t('users.entity_name') 
    }, 
    {
      id: 'email',
      idVista: [4, 7, 9, 10, 23, 27, 45, 46, 47, 50, 52, 53, 73, 77, 81, 84],
      label: i18n.tc('users.email', 1)
    }, 
    {
      id: 'company',
      idVista: [9, 23, 46],
      label: i18n.tc('companies.entity_name', 1) 
    }, 
    {
      id: 'role',
      idVista: [9, 23, 46],
      label: i18n.tc('app.role', 1)
    }, 
    {
      id: 'tipoAuth',
      idVista: [9, 23, 46],
      label: i18n.t('users.tipo_auth') 
    }, 
    {
      id: 'verTodo',
      idVista: [9, 23, 46],
      label: i18n.t('configurations.ver_todo') 
    }, 
    {
      id: 'verTodoStatuses',
      idVista: [9, 23, 45, 46, 50, 52, 53, 77],
      label: i18n.t('configurations.ver_todo_statuses') 
    }, 
    {
      id: 'verTodoCompanies',
      idVista: [9, 23, 45, 46, 50, 52, 53, 77],
      label: i18n.t('configurations.ver_todo_companies') 
    }, 
    {
      id: 'idioma',
      idVista: [9, 23, 46],
      label: i18n.t('app.language') 
    }, 
    {
      id: 'IdFacturaRecurrente',
      idVista: [40, 42],
      label: i18n.t('invoices.idFacturaRecurrente_long') 
    }, 
    {
      id: 'EstadoRecurrencia',
      idVista: [40, 42],
      label: i18n.t('invoices.recurrence_status') 
    }, 
    {
      id: 'fechaVencimientoDesde',
      idVista: [40, 42],
      label: i18n.t('SEPA.due_date_from') 
    }, 
    {
      id: 'fechaVencimientoHasta',
      idVista: [40, 42],
      label: i18n.t('SEPA.due_date_to') 
    }, 
    {
      id: 'SEPAGenerado',
      idVista: [40, 42],
      label: i18n.t('SEPA.entity_name')
    }, 
    {
      id: 'empresa',
      idVista: [4, 9, 23, 40, 41, 42, 43, 27, 45, 50, 52, 53, 57, 59, 62, 64, 66, 69, 73, 74, 75, 76, 77, 84, 94, 96],
      label: i18n.t('clients.entity_name') 
    }, 
    {
      id: 'cifEmpresa',
      idVista: [40],
      label: i18n.tc('companies.entity_name', 1)
    }, 
    {
      id: 'distribuidor',
      idVista: [4, 8, 9, 23, 29, 40, 41, 42, 43, 27, 45, 50, 52, 53, 62, 64, 66, 69, 73, 76, 77, 84, 94],
      label: i18n.t('distributors.entity_name') 
    }, 
    {
      id: 'certAsociado',
      idVista: [4, 73, 84],
      label: i18n.t('companies.cert_asociado') 
    }, 
    {
      id: 'ActiveReports',
      idVista: [4, 7, 10, 27, 73, 84],
      label: i18n.t('companies.active_reports') 
    }, 
    {
      id: 'cif',
      idVista: [4, 7, 10, 27, 40, 41, 42, 43, 47, 73, 80, 84],
      label: i18n.t('companies.cif') 
    }, 
    {
      id: 'name',
      idVista: [4, 7, 10, 27, 47, 73, 84],
      label: i18n.t('companies.companyName') 
    }, 
    {
      id: 'send_alerts',
      idVista: [4, 7, 10, 27, 45, 47, 50, 52, 53, 73, 77, 84],
      label: i18n.t('app.send_alerts') 
    }, 
    {
      id: 'FechaNotificacionDesde',
      idVista: [93],
      label: i18n.t('verifactu.filters.noification_from'),
      type: 'date' 
    }, 
    {
      id: 'FechaNotificacionHasta',
      idVista: [93],
      label: i18n.t('verifactu.filters.noification_to'),
      type: 'date' 
    }, 
    {
      id: 'FechaExpedicionDesde',
      idVista: [93],
      label: i18n.t('verifactu.filters.expedition_from'),
      type: 'date' 
    }, 
    {
      id: 'FechaExpedicionHasta',
      idVista: [93],
      label: i18n.t('verifactu.filters.expedition_to'),
      type: 'date' 
    }, 
    {
      id: 'FechaAltaDesde',
      idVista: [93],
      label: i18n.t('app.filters.fecha_alta_from'),
      type: 'date' 
    }, 
    {
      id: 'FechaAltaHasta',
      idVista: [93],
      label: i18n.t('app.filters.fecha_alta_to'),
      type: 'date' 
    }, 
    {
      id: 'fechaAltaDesde',
      idVista: [4, 7, 10, 27, 47, 73, 84],
      label: i18n.t('app.filters.fecha_alta_from'),
      type: 'date' 
    }, 
    {
      id: 'fechaCreacionDesde',
      idVista: [96],
      label: 'F. creación desde',
      type: 'date' 
    }, 
    {
      id: 'fechaCreacionHasta',
      idVista: [96],
      label: 'F. creación hasta',
      type: 'date' 
    }, 
    {
      id: 'descripcion',
      idVista: [96],
      label: i18n.t('invoices.invoices_issuing.descripcion'),
    }, 
    {
      id: 'nombreFlujo',
      idVista: [96],
      label: i18n.t('app.name'),
    }, 
    {
      id: 'fechaAltaHasta',
      idVista: [4, 7, 10, 27, 43, 47, 73, 84],
      label: i18n.t('app.filters.fecha_alta_to'),
      type: 'date' 
    }, 
    {
      id: 'estado',
      idVista: [4, 7, 10, 27, 47, 73],
      label: i18n.t('app.active') 
    }, 
    {
      id: 'activo',
      idVista: [8, 9, 23, 76, 79, 84, 90, 96, 98],
      label: i18n.t('app.active') 
    },
    {
      id: 'active',
      idVista: [46],
      label: i18n.t('app.active') 
    },
    {
      id: 'tipoInvoiceClass',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.tipo_factura') 
    }, 
    {
      id: 'pge',
      idVista: [40, 41, 42, 43],
      label: i18n.t('app.forma_envio') 
    }, 
    {
      id: 'PGE',
      idVista: [40, 41, 42, 43],
      label: i18n.t('app.forma_envio') 
    }, 
    {
      id: 'CuotaTotalDesde',
      idVista: [93],
      label: i18n.t('verifactu.filters.quota_from'),
      type: 'number' 
    }, 
    {
      id: 'CuotaTotalHasta',
      idVista: [93],
      label: i18n.t('verifactu.filters.quota_to'),
      type: 'number' 
    }, 
    {
      id: 'ImporteTotalDesde',
      idVista: [93],
      label: i18n.t('verifactu.filters.amount_from'),
      type: 'number' 
    }, 
    {
      id: 'ImporteTotalHasta',
      idVista: [93],
      label: i18n.t('verifactu.filters.amount_to'),
      type: 'number' 
    }, 
    {
      id: 'importeDesde',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.filters.invoice_importe_min'),
      type: 'number' 
    }, 
    {
      id: 'importeHasta',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.filters.invoice_importe_max'),
      type: 'number' 
    }, 
    {
      id: 'tipo',
      idVista: [40, 41, 42, 43],
      label: i18n.t('app.type') 
    }, 
    {
      id: 'tipoNotif',
      idVista: [40, 41, 42, 43],
      label: i18n.t('app.type') 
    }, 
    {
      id: 'estadoExtra',
      idVista: [40, 41, 42, 43],
      label: i18n.t('app.status') 
    }, 
    {
      id: 'estadoExtraRecibidas',
      idVista: [40, 41, 42, 43],
      label: i18n.t('app.status') 
    }, 
    {
      id: 'estado',
      idVista: [40, 41, 42, 43],
      label: i18n.t('app.status') 
    }, 
    {
      id: 'pendienteAprobacion',
      idVista: [41, 43],
      label: i18n.t('tipos.estado_recibidas.wait_approving')
    },
    {
      id: 'esOCREditable',
      idVista: [41, 43],
      label: i18n.t('tipos.estado_recibidas.wait_reviewing')
    },
    {
      id: 'esTurnoUsuario',
      idVista: [41, 43],
      label: i18n.t('approval_workflow.workflow_turn')
    },
    {
      id: 'asunto',
      idVista: [40, 41, 42, 43],
      label: i18n.t('personalization.mail_asunto') 
    }, 
    {
      id: 'idInterno',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.internal_id_short') 
    }, 
    {
      id: 'textoLibre',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.filters.textoLibre') 
    }, 
    {
      id: 'ultimoError',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.error_temporal') 
    }, 
    {
      id: 'motivoRechazo',
      idVista: [40, 42, 43],
      label: i18n.t('configurations.reject_msgs') 
    }, 
    {
      id: 'NombreCIF',
      idVista: [40, 41, 42, 43],
      label: i18n.t('companies.companyName') 
    }, 
    {
      id: 'evento',
      idVista: [18, 19, 20, 21, 22, 24, 26, 28, 30, 49, 51, 56, 58, 60, 63, 65, 67, 70, 78, 91, 95],
      label: i18n.t('historical.event_name') 
    },
    {
      id: 'mensaje',
      idVista: [18, 19, 20, 21, 22, 24, 26, 28, 30, 49, 51, 56, 58, 60, 63, 65, 67, 70, 78, 91, 95],
      label: i18n.t('historical.info') 
    }, 
    {
      id: 'fechaDesde',
      idVista: [18, 19, 20, 21, 22, 24, 26, 28, 30, 49, 51, 56, 58, 60, 63, 65, 67, 70, 78, 91, 94, 95],
      label: i18n.t('historical.fechaDesde'),
      type: 'date' 
    }, 
    {
      id: 'fechaHasta',
      idVista: [18, 19, 20, 21, 22, 24, 26, 28, 30, 49, 51, 56, 58, 60, 63, 65, 67, 70, 78, 91, 94, 95],
      label: i18n.t('historical.fechaHasta'),
      type: 'date' 
    }, 
    // {
    //   id: 'name',
    //   idVista: [8],
    //   label: i18n.t('app.name') 
    // }, 
    {
      id: 'codigoExterno',
      idVista: [8],
      label: i18n.t('clients.cod_ext') 
    }, 
    {
      id: 'ns',
      idVista: [8],
      label: i18n.t('app.serial_number') 
    }, 
    {
      id: 'partner',
      idVista: [8],
      label: i18n.t('clients.partner') 
    }, 
    {
      id: 'grupoCliente',
      idVista: [8],
      label: i18n.t('clients.grupo_cliente') 
    }, 
    {
      id: 'tipoServicio',
      idVista: [8],
      label: i18n.t('clients.service_type') 
    }, 
    {
      id: 'PagarAlContabilizar',
      idVista: [8],
      label: i18n.t('clients.factura_submenu.auto_paid') 
    }, 
    {
      id: 'PendienteFacturacion',
      idVista: [8],
      label: i18n.t('clients.filters.alta_fact_filter') 
    }, 
    {
      id: 'expires_from',
      idVista: [6, 29],
      label: i18n.t('certificates.expires_date_from') 
    }, 
    {
      id: 'expires_to',
      idVista: [6, 29],
      label: i18n.t('certificates.expires_date_to') 
    }, 
    {
      id: 'name',
      idVista: [6, 8, 29, 98],
      label: i18n.t('app.name') 
    }, 
    {
      id: 'serial',
      idVista: [6, 29],
      label: i18n.t('certificates.serial') 
    }, 
    {
      id: 'empresa',
      idVista: [6, 29],
      label: i18n.t('clients.entity_name') 
    }, 
    {
      id: 'tipoCert',
      idVista: [6, 29],
      label: i18n.t('app.type') 
    }, 
    {
      id: 'enUso',
      idVista: [6, 29, 45, 50, 52, 53, 76, 77, 79, 98],
      label: i18n.t('app.in_use') 
    }, 
    {
      id: 'propietario',
      idVista: [53],
      label: i18n.t('groups.owner') 
    }, 
    {
      id: 'notas',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.notas') 
    }, 
    {
      id: 'contieneAdjuntos',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.adjuntos_included') 
    }, 
    {
      id: 'OrigenFactura',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.filters.origen_factura') 
    }, 
    {
      id: 'metadatos',
      idVista: [40, 41, 42, 43],
      label: i18n.tc('invoices.metadatos.metadato', 1)
    }, 
    {
      id: 'temporal',
      idVista: [10, 12, 52],
      label: i18n.tc('groups.temporal', 1)
    }, 
    {
      id: 'tipoGrupo',
      idVista: [45, 50, 52, 53, 77],
      label: i18n.t('app.type') 
    }, 
    {
      id: 'verTodoGroups',
      idVista: [45, 50, 52, 53, 77],
      label: i18n.t('configurations.ver_todo_groups') 
    }, 
    {
      id: 'nombreGrupo',
      idVista: [9, 23, 40, 41, 42, 43, 76, 79, 98],
      label: i18n.t('groups.entity_name') 
    }, 
    {
      id: 'nombreGrupoPropietario',
      idVista: [40, 41, 42, 43, 76, 79, 98],
      label: i18n.t('groups.group_owner') 
    }, 
    {
      id: 'name',
      idVista: [55],
      label: i18n.t('app.name') 
    }, 
    {
      id: 'tipoDistribuidor',
      idVista: [55],
      label: i18n.t('distributors.tipo_distribuidor') 
    }, 
    {
      id: 'tipoProvisionamiento',
      idVista: [55],
      label: i18n.t('distributors.tipo_provisionamiento') 
    }, 
    {
      id: 'permiteWizard',
      idVista: [55],
      label: i18n.t('clients.permite_wizard')
    },
    {
      id: 'permiteIntegracionZoho',
      idVista: [55],
      label: i18n.t('clients.integracion_zoho')
    },
    {
      id: 'fechaFacturaDesde',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.filters.invoice_date_from'),
      type: 'date' 
    }, 
    {
      id: 'fechaFacturaHasta',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.filters.invoice_date_to'),
      type: 'date' 
    }, 
    {
      id: 'fechaEntradaERPDesde',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.filters.erp_entry_date_from'),
      type: 'date' 
    }, 
    {
      id: 'fechaEntradaERPHasta',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.filters.erp_entry_date_to'),
      type: 'date' 
    }, 
    {
      id: 'fechaAltaDesde',
      idVista: [40, 41, 42, 43],
      label: i18n.t('app.filters.fecha_alta_from'),
      type: 'date' 
    }, 
    {
      id: 'fechaAltaHasta',
      idVista: [40, 41, 42, 43],
      label: i18n.t('app.filters.fecha_alta_to'),
      type: 'date' 
    }, 
    {
      id: 'fechaPagoDesde',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.filters.fecha_pago_from'),
      type: 'date' 
    }, 
    {
      id: 'fechaPagoHasta',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.filters.fecha_pago_to'),
      type: 'date' 
    }, 
    {
      id: 'fechaRechazoDesde',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.filters.fecha_rechazo_from'),
      type: 'date' 
    }, 
    {
      id: 'fechaRechazoHasta',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.filters.fecha_rechazo_to'),
      type: 'date' 
    }, 
    {
      id: 'IdTBAI',
      idVista: [40, 42],
      label: i18n.t('invoices.id_ticketbai')
    }, 
    {
      id: 'fechaTicketBaiDesde',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.filters.fecha_ticketbai_from'),
      type: 'date' 
    }, 
    {
      id: 'fechaTicketBaiHasta',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.filters.fecha_ticketbai_to'),
      type: 'date' 
    }, 
    {
      id: 'csvTicketbai',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.id_ticketbai') 
    }, 
    {
      id: 'estadoTicketbai',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.estado_ticketbai') 
    }, 
    {
      id: 'numFactura',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.num_factura') 
    }, 
    {
      id: 'SerieFactura',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.serie_factura') 
    }, 
    {
      id: 'cifEmisor',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.cif_emisor') 
    }, 
    {
      id: 'NombreCIFEmisor',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.emisor') 
    }, 
    {
      id: 'cifReceptor',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.cif_receptor') 
    }, 
    {
      id: 'NombreCIFReceptor',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.receptor') 
    }, 
    {
      id: 'CodCliente',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.client_code') 
    },
    {
      id: 'importe',
      idVista: [40, 41, 42, 43],
      label: i18n.t('invoices.importe'),
      type: 'number' 
    }, 
    {
      id: 'PGE',
      idVista: [43, 44],
      label: i18n.t('companies.configuration_rec.pge') 
    }, 
    {
      id: 'DIR',
      idVista: [44],
      label: i18n.t('companies.configuration_rec.dir3_dire') 
    },
    {
      id: 'dirReceptor',
      idVista: [41],
      label: i18n.t('companies.configuration_rec.dir3_dire') 
    },  
    {
      id: 'tipoGrupo',
      idVista: [45, 50, 52, 53, 77],
      label: i18n.t('configurations.tipo_grupo') 
    }, 
    {
      id: 'metadatos',
      idVista: [40, 41, 42, 43],
      label: i18n.tc('invoices.metadatos.metadato', 1)
    }, 
    {
      id: 'Cliente',
      idVista: [57, 59, 74, 75],
      label: i18n.t('clients.entity_name') 
    }, 
    {
      id: 'IdEstadoVerifactu',
      idVista: [93],
      label: i18n.t('app.status') 
    },
    {
      id: 'IdAccionVerifactu',
      idVista: [93],
      label: i18n.t('verifactu.action_type') 
    },
    {
      id: 'IdTipoFactura',
      idVista: [93],
      label: i18n.t('verifactu.invoice_type.entity_name') 
    },
    {
      id: 'idCliente',
      idVista: [93],
      label: i18n.t('clients.entity_name') 
    },
    {
      id: 'idDistribuidor',
      idVista: [93],
      label: i18n.t('distributors.entity_name') 
    },
    {
      id: 'idCifEmpresa',
      idVista: [93],
      label: i18n.t('verifactu.company_cif') 
    },
    {
      id: 'Empresa',
      idVista: [93],
      label: i18n.tc('companies.entity_name', 1) 
    },
    {
      id: 'NumSerieFactura',
      idVista: [93],
      label: i18n.t('invoices.serie_factura') 
    },
    {
      id: 'HuellaRegistro',
      idVista: [93],
      label: i18n.t('verifactu.register_print') 
    },
    {
      id: 'CSVZC',
      idVista: [93],
      label: i18n.t('verifactu.csvzc') 
    },
    {
      id: 'csv',
      idVista: [40, 42, 43],
      label: i18n.t('invoices.csv') 
    },
    {
      id: 'CSVAEAT',
      idVista: [93],
      label: i18n.t('verifactu.csvaeat')
    },
    {
      id: 'NumAsiento',
      idVista: [42, 43],
      label: i18n.t('invoices.seat_number')
    },
    {
      id: 'Book',
      idVista: [57, 59, 74, 75],
      label: i18n.t('contacto.Book') 
    }, 
    {
      id: 'Sheet',
      idVista: [57, 59, 74, 75],
      label: i18n.t('contacto.Sheet') 
    }, 
    {
      id: 'Folio',
      idVista: [57, 59, 74, 75],
      label: i18n.t('contacto.Folio') 
    }, 
    {
      id: 'Section',
      idVista: [57, 59, 74, 75],
      label: i18n.t('contacto.Section') 
    }, 
    {
      id: 'Volume',
      idVista: [57, 59, 74, 75],
      label: i18n.t('contacto.Volume') 
    }, 
    {
      id: 'AdditionalData',
      idVista: [57, 59, 74, 75],
      label: i18n.t('agenda.additional_data') 
    }, 
    {
      id: 'PersonTypeCode',
      idVista: [57, 59, 74, 75],
      label: i18n.t('agenda.PersonTypeCode') 
    }, 
    {
      id: 'PersonType',
      idVista: [57, 59, 74, 75, 80],
      label: i18n.t('agenda.PersonTypeCode') 
    }, 
    {
      id: 'ResidenceTypeCode',
      idVista: [57, 59, 74, 75],
      label: i18n.t('agenda.ResidenceTypeCode') 
    }, 
    {
      id: 'ResidenceType',
      idVista: [57, 59, 74, 75, 80],
      label: i18n.t('agenda.ResidenceTypeCode') 
    }, 
    {
      id: 'TaxIdentificationNumber',
      idVista: [57, 59, 74, 75],
      label: i18n.t('agenda.TaxIdentificationNumber') 
    }, 
    {
      id: 'CIF',
      idVista: [57, 59, 73, 74, 75, 84, 93],
      label: i18n.t('agenda.cif') 
    }, 
    {
      id: 'SIF',
      idVista: [93],
      label: i18n.t('verifactu.sif') 
    }, 
    {
      id: 'enviarAvisos',
      idVista: [73],
      label: i18n.t('app.send_alerts') 
    }, 
    {
      id: 'razonSocial',
      idVista: [73],
      label: i18n.t('agenda.RazonSocial') 
    }, 
    {
      id: 'RazonSocial',
      idVista: [57, 59, 74, 75],
      label: i18n.t('agenda.RazonSocial') 
    }, 
    {
      id: 'Name',
      idVista: [57, 59, 61, 62, 74, 75, 72],
      label: i18n.t('app.name') 
    }, 
    {
      id: 'FirstSurname',
      idVista: [57, 59, 61, 74, 75, 80],
      label: i18n.t('persons_data.firstsurname') 
    }, 
    {
      id: 'SecondSurname',
      idVista: [57, 59, 61, 74, 75, 80],
      label: i18n.t('persons_data.secondsurname') 
    }, 
    {
      id: 'RolAgenda',
      idVista: [57, 59, 74, 75],
      label: i18n.tc('agenda.rol', 1)
    }, 
    {
      id: 'roleType',
      idVista: [57],
      label: i18n.tc('agenda.rol', 1)
    },
    {
      id: 'CentreCode',
      idVista: [61],
      label: i18n.t('administrativecenter.CentreCode') 
    }, 
    {
      id: 'RoleCode',
      idVista: [61],
      label: i18n.t('administrativecenter.RoleTypeCode') 
    }, 
    {
      id: 'PhysicalIGLN',
      idVista: [61],
      label: i18n.t('administrativecenter.PhysicalGLN') 
    }, 
    {
      id: 'LogicalOperationalPoint',
      idVista: [61],
      label: i18n.t('administrativecenter.LogicalOperationalPoint') 
    }, 
    {
      id: 'CentreDescription',
      idVista: [61],
      label: i18n.t('administrativecenter.CentreDescription') 
    }, 
    {
      id: 'Address',
      idVista: [61, 71, 82],
      label: i18n.t('address.location') 
    }, 
    {
      id: 'Province',
      idVista: [61, 71, 82],
      label: i18n.t('address.provincia') 
    }, 
    {
      id: 'PostCode',
      idVista: [61, 71, 82],
      label: i18n.t('address.codigo_postal') 
    }, 
    {
      id: 'Town',
      idVista: [61, 71, 82],
      label: i18n.t('address.poblacion') 
    }, 
    {
      id: 'Telephone',
      idVista: [61, 71],
      label: i18n.t('address.telefono') 
    }, 
    {
      id: 'TeleFax',
      idVista: [61, 71],
      label: i18n.t('administrativecenter.telefax') 
    }, 
    {
      id: 'WebAddress',
      idVista: [61, 71],
      label: i18n.t('contacto.WebAddress') 
    }, 
    {
      id: 'ElectronicMail',
      idVista: [61, 71, 83],
      label: i18n.t('contacto.ElectronicMail') 
    }, 
    {
      id: 'ContactPersons',
      idVista: [61, 71],
      label: i18n.t('contacto.entity_name_plural') 
    }, 
    {
      id: 'CnoCnae',
      idVista: [61, 71],
      label: i18n.t('administrativecenter.cno_cnae') 
    }, 
    {
      id: 'INETownCode',
      idVista: [61, 71],
      label: i18n.t('administrativecenter.INE_town_code') 
    }, 
    {
      id: 'AdditionalDetails',
      idVista: [61, 71],
      label: i18n.t('administrativecenter.additional_details') 
    }, 
    {
      id: 'DIRE',
      idVista: [71],
      label: i18n.t('companies.configuration_rec.dire') 
    }, 
    {
      id: 'CountryCode',
      idVista: [61, 71, 82],
      label: i18n.t('address.pais') 
    }, 
    {
      id: 'Code',
      idVista: [72],
      label: i18n.t('configurations.code') 
    }, 
    {
      id: 'Role',
      idVista: [72],
      label: i18n.tc('app.role', 1)
    }, 
    {
      id: 'NameCorporateName',
      idVista: [57, 59, 74, 75, 80],
      label: i18n.t('app.name') 
    }, 
    {
      id: 'TIN',
      idVista: [57, 59, 74, 75, 80],
      label: i18n.t('agenda.cif') 
    }, 
    {
      id: 'Locations',
      idVista: [57, 59, 75, 80],
      label: i18n.t('sedes.header') 
    }, 
    {
      id: 'LinkedCompanies',
      idVista: [57, 59, 75, 80],
      label: i18n.t('companies.companies_link') 
    }, 
    {
      id: 'RegisterOfCompaniesLocation',
      idVista: [57, 59, 74, 75, 80],
      label: i18n.t('contacto.RegisterOfCompaniesLocation') 
    }, 
    {
      id: 'Name',
      idVista: [62, 64, 68, 71],
      label: i18n.t('app.name') 
    }, 
    {
      id: 'TaxType',
      idVista: [62, 64, 68],
      label: i18n.t('impuestos.TaxType') 
    }, 
    {
      id: 'TaxRate',
      idVista: [62, 64, 68],
      label: i18n.t('impuestos.TaxRate') 
    }, 
    {
      id: 'TaxCategory',
      idVista: [62, 64, 68],
      label: i18n.t('impuestos.TaxCategory') 
    }, 
    {
      id: 'equivalenceSurchargeMin',
      idVista: [62, 64, 68],
      label: i18n.t('impuestos.equivalence_surcharge_min') 
    },
    {
      id: 'equivalenceSurchargeMax',
      idVista: [62, 64, 68],
      label: i18n.t('impuestos.equivalence_surcharge_max') 
    },
    {
      id: 'CoverEquivalenceSurcharge',
      idVista: [57, 59],
      label: i18n.t('impuestos.equivalence_surcharge_covered') 
    },
    {
      id: 'taxRateMin',
      idVista: [62, 64, 68],
      label: i18n.t('impuestos.TaxRate_min') 
    }, 
    {
      id: 'taxRateMax',
      idVista: [62, 64, 68],
      label: i18n.t('impuestos.TaxRate_max') 
    }, 
    {
      id: 'ItemDescription',
      idVista: [66, 69],
      label: i18n.t('products.ItemDescription') 
    }, 
    {
      id: 'UnitOfMeasure',
      idVista: [66, 69],
      label: i18n.t('products.UnitOfMeasure') 
    }, 
    {
      id: 'UnitPriceWithoutTax',
      idVista: [66, 69],
      label: i18n.t('products.UnitPriceWithoutTax') 
    }, 
    {
      id: 'UnitPriceWithoutTaxMin',
      idVista: [66, 69],
      label: i18n.t('products.UnitPriceWithoutTax_min') 
    }, 
    {
      id: 'UnitPriceWithoutTaxMax',
      idVista: [66, 69],
      label: i18n.t('products.UnitPriceWithoutTax_max') 
    }, 
    {
      id: 'ArticleCode',
      idVista: [66, 69],
      label: i18n.t('products.ArticleCode') 
    }, 
    {
      id: 'LocationName',
      idVista: [71],
      label: i18n.t('app.name') 
    }, 
    {
      id: 'SendType',
      idVista: [71],
      label: i18n.t('app.forma_envio') 
    }, 
    {
      id: 'Email',
      idVista: [83, 71],
      label: i18n.tc('users.email', 1)
    }, 
    {
      id: 'Email',
      idVista: [83],
      label: i18n.t('contact_email.entity_name') 
    }, 
    {
      id: 'PaymentType',
      idVista: [82],
      label: i18n.t('invoices.invoices_issuing.step6.header') 
    }, 
    {
      id: 'AccountType',
      idVista: [82],
      label: i18n.t('agenda.account_type') 
    }, 
    {
      id: 'IBANAccountNumber',
      idVista: [82],
      label: i18n.t('invoices.invoices_issuing.iban') 
    }, 
    {
      id: 'BankCode',
      idVista: [82],
      label: i18n.t('agenda.bank_code') 
    }, 
    {
      id: 'BranchCode',
      idVista: [82],
      label: i18n.t('agenda.branch_code') 
    }, 
    {
      id: 'BIC',
      idVista: [82],
      label: i18n.t('invoices.invoices_issuing.bic_swift') 
    }, 
    {
      id: 'domiciliationFrom',
      idVista: [82],
      label: i18n.t('app.from') 
    }, 
    {
      id: 'domiciliationTo',
      idVista: [82],
      label: i18n.t('app.to') 
    }, 
    {
      id: 'SEPAIdentifier',
      idVista: [82],
      label: i18n.t('agenda.SEPA_Identifier')
    },
    {
      id: 'FaceB2Bcode',
      idVista: [71],
      label: i18n.t('sedes.FaceB2Bcode') 
    }, 
    {
      id: 'FaceB2Bname',
      idVista: [71],
      label: i18n.t('sedes.FaceB2Bname') 
    }, 
    {
      id: 'codefb2b',
      idVista: [72],
      label: i18n.t('app.code') 
    }, 
    {
      id: 'namefb2b',
      idVista: [72],
      label: i18n.t('app.name') 
    }, 
    {
      id: 'rolefb2b',
      idVista: [72],
      label: i18n.tc('app.role', 1)
    }, 
    {
      id: 'agrupacionCIF',
      idVista: [40, 41, 42, 43, 73],
      label: i18n.tc('grouping.grouping_companies', 1)
    }, 
    {
      id: 'agrupacionCliente',
      idVista: [40, 41, 42, 43, 74, 75],
      label: i18n.tc('grouping.grouping_buyers', 1)
    }, 
    {
      id: 'agrupacionProveedor',
      idVista: [40, 41, 42, 43, 74, 75],
      label: i18n.tc('grouping.grouping_sellers', 1)
    }, 
    {
      id: 'nombreAgrupacion',
      idVista: [4, 7, 10, 46, 57, 73, 74, 75, 84],
      label: i18n.t('grouping.entity_name') 
    }, 
    {
      id: 'nombreAgrupacionSeller',
      idVista: [57, 74, 75],
      label: i18n.tc('grouping.grouping_sellers', 1)
    }, 
    {
      id: 'nombreAgrupacionBuyer',
      idVista: [57, 74, 75],
      label: i18n.tc('grouping.grouping_buyers', 1)
    }, 
    {
      id: 'prioridad',
      idVista: [76, 79, 98],
      label: i18n.t('configurations.prioridad') 
    }, 
    {
      id: 'EnEmision',
      idVista: [76, 79],
      label: i18n.t('configurations.en_emision') 
    }, 
    {
      id: 'DetenerEjecucion',
      idVista: [76, 79, 98],
      label: i18n.t('rules.detener_ejecucion') 
    }, 
    {
      id: 'EnviarAutomaticamente',
      idVista: [76, 79],
      label: i18n.t('configurations.envia_auto') 
    }, 
    {
      id: 'url',
      idVista: [90],
      label: i18n.t('app.url') 
    }, 
    {
      id: 'notificationType',
      idVista: [90],
      label: i18n.t('app.type') 
    },
    {
      id: 'tipoImportacion',
      idVista: [94],
      label: i18n.t('imports.type')
    },
    {
      id: 'tipoImportacionEstado',
      idVista: [94],
      label: i18n.t('imports.status')
    },
    {
      id: 'PaqueteContratacion',
      idVista: [8],
      label: i18n.t('clients.paquete_contratacion')
    },
    {
      id: 'FaseConfiguracion',
      idVista: [8],
      label: i18n.t('clients.fase_config')
    },
    {
      id: 'usuario',
      idVista: [94],
      label: i18n.t('configurations.username')
    },
    {
      id: 'ModulosContratados',
      idVista: [8],
      label: i18n.t('clients.modulos_contratados')
    },
    {
      id: 'certificadoSAML2Caducado',
      idVista: [8],
      label: i18n.t('clients.certificadoSAML2Caducado_filter')
    },
    {
      id: 'certificadoSAML2PorCaducar',
      idVista: [8],
      label: i18n.t('clients.certificadoSAML2PorCaducar_filter')
    },
  ]
}

export function LABEL_FILTROS (state) {
  return configHelper.getConfig(state, 'LABEL_FILTROS', GenerateConfig)
}
